import {createStackNavigator } from '@react-navigation/stack';

const  Stack = createStackNavigator();

import LandingScreen from '../screens/Landing/LandingScreen';
import IdentityScreen  from '../screens/Login/IdentityScreen';

import {Routes} from './Routes';
import Dish from '../screens/Dish/Dish';
import SignUpScreen from '../screens/Login/SignUpScreen';
import ConfirmSignUpScreen from '../screens/Login/ConfirmSignUpScreen';
import ConfirmSignUpWithPinScreen from '../screens/Login/ConfirmSignUpWithPinScreen';
import {
  Platform,
  Pressable,
  Text,
  View,
  Image,
  StyleSheet,
} from 'react-native';
import SignInScreen from '../screens/Login/SignInScreen';
import ConsumerPostNeed from '../screens/ConsumerPostNeed/ConsumerPostNeed';
import CreateDishScreen from '../screens/Dish/CreateDishScreen';
import ProviderPostServices from '../screens/ProviderPostServices/ProviderPostServices';
import OfferHelp from '../screens/Offer/OfferHelp';
import ProviderGetMyServices from '../screens/ProviderGetMyServices/ProviderGetMyServices';
import ForgotPasswordScreen from '../screens/Login/ForgotPasswordScreen';
import ProviderAdvertiseForm from '../screens/ProviderAdvertiseForm/ProviderAdvertiseForm';
import Home from '../screens/Home/Home';
import ConsumerFollowing from '../screens/ConsumerFollowing/ConsumerFollowing';
import ProviderDetails from '../screens/ProviderDetails/ProviderDetails';
import AdvertisePlaceholder from '../screens/Helper/AdvertisePlaceholder';
import AllServices from '../screens/AllServices/AllServices';
import AllMyAsks from '../screens/AllMyAsks/AllMyAsks';
import CEat from '../screens/ProviderGetEatFromConsumer/CEat';
import CLive from '../screens/ProviderGetLiveFromConsumer/CLive';
import CMove from '../screens/ProviderGetMoveFromConsumer/CMove';
import PEat from '../screens/ConsumeGetEatFromProvider/PEat';
import PLive from '../screens/ConsumeGetLiveFromProvider/PLive';
import PMove from '../screens/ConsumeGetMoveFromProvider/PMove';
import ItemOffers from '../screens/AllOffers/ItemOffers';
const MainNavigation = () =>{

  const HeaderTitle = (
    <View style={navStyle.flexStyle}>

      <View style={navStyle.myView}>
        <Text
          accessibilityRole="header"
          style={navStyle.txtStyle1}
        >
          Eabu
        </Text>
        <Text
          style={navStyle.txtStyle2}
        >
          Food and Beyond - Locally
        </Text>
      </View>
    </View>


  );


  const authRoutes = new Set([
    Routes.SignUpScreen,
    Routes.SignInScreen,
    Routes.ConfirmSignUpScreen,
    Routes.ConfirmSignUpWithPinScreen,
    Routes.ForgotPassword,
    Routes.IdentityScreen,
  ]);

  return <Stack.Navigator  initialRouteName={Platform.OS === 'web' ? Routes.Landing : Routes.SignUpScreen}
                           screenOptions={({ navigation, route }) => ({
                             headerShown: true,
                             headerTitleAlign: 'center',
                             headerTitle: () => HeaderTitle,
                             headerStyle: {
                               backgroundColor: Platform.select({
                                 ios: '#0A84FF',
                                 android: '#0EA5E9',
                                 default: '#0EA5E9',
                               }),
                               height: Platform.select({ ios: 96, android: 88, default: 88 }),
                               elevation: 0,
                             },
                             headerTintColor: '#FFFFFF',
                             headerShadowVisible: false,
                             headerBackTitleVisible: false,
                             headerBackTitle: '',
                             headerBackTitleStyle: { display: 'none' },
                             headerBackVisible: false,
                             headerLeft: () => null,
                             headerRight: () => (authRoutes.has(route.name) ? null : (
                               <Pressable
                                 onPress={() => navigation.reset({
                                   index: 0,
                                   routes: [{ name: Routes.Home }],
                                 })}
                                 accessibilityRole="button"
                                 accessibilityLabel="Go to Home"
                                 hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                                 style={({ pressed }) => ({
                                   opacity: pressed ? 0.6 : 1,
                                   paddingHorizontal: 12,
                                   paddingVertical: 6,
                                 })}
                               >
                                 <Text style={navStyle.txtStyle3}>Home</Text>
                               </Pressable>
                             ))
                           })}
  >
    <Stack.Screen name={Routes.Landing} component={LandingScreen} options={{headerShown: false}} />
    <Stack.Screen name={Routes.SignUpScreen} component={SignUpScreen} />
    <Stack.Screen name={Routes.IdentityScreen} component={IdentityScreen}/>
    <Stack.Screen name={Routes.Home} component={Home} />
    <Stack.Screen name={Routes.Dish} component={Dish} />
    <Stack.Screen name={Routes.ConfirmSignUpScreen} component={ConfirmSignUpScreen} />
    <Stack.Screen name={Routes.ConfirmSignUpWithPinScreen} component={ConfirmSignUpWithPinScreen} />
    <Stack.Screen name={Routes.SignInScreen} component={SignInScreen} />
    <Stack.Screen name={Routes.ConsumerPostNeed} component={ConsumerPostNeed} />
    <Stack.Screen name={Routes.ProviderPostServices} component={ProviderPostServices} />
    <Stack.Screen name={Routes.CreateDishScreen} component={CreateDishScreen} />
    <Stack.Screen name={Routes.OfferHelp} component={OfferHelp} />
    <Stack.Screen name={Routes.ProviderGetMyServices} component={ProviderGetMyServices} />
    <Stack.Screen name={Routes.ForgotPassword} component={ForgotPasswordScreen} />
    <Stack.Screen name={Routes.ProviderAdvertiseForm} component={ProviderAdvertiseForm} />
    <Stack.Screen name={Routes.ConsumerFollowing} component={ConsumerFollowing} />
    <Stack.Screen name={Routes.ProviderDetails} component={ProviderDetails} />
    <Stack.Screen name={Routes.AdvertisePlaceholder} component={AdvertisePlaceholder} />
    <Stack.Screen name={Routes.ConsumerGetEatFromProvider} component={PEat} />
    <Stack.Screen name={Routes.ConsumerGetLiveFromProvider} component={PLive} />
    <Stack.Screen name={Routes.ConsumerGetMoveFromProvider} component={PMove} />
    <Stack.Screen name={Routes.AllServices} component={AllServices} />
    <Stack.Screen name={Routes.AllMyAsks} component={AllMyAsks} />
    <Stack.Screen name={Routes.ProviderGetEatFromConsumer} component={CEat} />
    <Stack.Screen name={Routes.ProviderGetLiveFromConsumer} component={CLive} />
    <Stack.Screen name={Routes.ProviderGetMoveFromConsumer} component={CMove} />
    <Stack.Screen name={Routes.ItemOffers} component={ItemOffers} />

  </Stack.Navigator>
}

const navStyle = StyleSheet.create({
  flexStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 10,
  },
  myView: {
    alignItems: 'center',
    paddingBottom: 10,
  },
  txtStyle1: {
    color: '#FFFFFF',
    fontSize: 22,
    fontWeight: '800',
    letterSpacing: 0.3,
  },
  txtStyle2: {
    color: '#FFFFFFCC',
    fontSize: 13,
    marginTop: 2,
    textAlign: 'center',
  },
  txtStyle3: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
});


export default MainNavigation
